<template>
    <div class="rent-cancellation-overlay" @click.self="close">
        <div class="rent-cancellation-modal">
            <button
                v-if="step !== 'loading'"
                type="button"
                class="rent-cancellation-close"
                @click="close"
            >
                <img :src="closeIcon" alt="Закрыть">
            </button>

            <template v-if="step === 'confirm'">
                <img :src="infoIcon" alt="" class="rent-cancellation-icon">
                <h3 class="rent-cancellation-title">Вы действительно хотите отменить бронирование?</h3>
                <p v-if="confirmText" class="rent-cancellation-text">{{ confirmText }}</p>
                <div class="rent-cancellation-actions rent-cancellation-actions--row">
                    <button type="button" class="rent-cancellation-secondary" @click="close">Назад</button>
                    <button type="button" class="rent-cancellation-danger" @click="$emit('confirm')">Да, отменить</button>
                </div>
            </template>

            <template v-else-if="step === 'late-cancel'">
                <img :src="infoIcon" alt="" class="rent-cancellation-icon">
                <h3 class="rent-cancellation-title">Поздняя отмена</h3>
                <p class="rent-cancellation-text">При отмене брони услуга будет списана. Вы уверены, что хотите продолжить?</p>
                <div class="rent-cancellation-actions rent-cancellation-actions--row">
                    <button type="button" class="rent-cancellation-secondary" @click="close">Оставить бронь</button>
                    <button type="button" class="rent-cancellation-danger" @click="$emit('confirm')">Отменить бронь</button>
                </div>
            </template>

            <template v-else-if="step === 'loading'">
                <h3 class="rent-cancellation-title">Отмена брони</h3>
                <div class="rent-cancellation-spinner-wrap">
                    <span class="rent-cancellation-spinner"></span>
                </div>
                <p class="rent-cancellation-text">{{ loadingText }}</p>
            </template>

            <template v-else-if="step === 'success'">
                <img :src="successIcon" alt="" class="rent-cancellation-icon">
                <h3 class="rent-cancellation-title">Бронь отменена</h3>
                <p v-if="successText" class="rent-cancellation-text">{{ successText }}</p>
                <div class="rent-cancellation-actions">
                    <button type="button" class="rent-cancellation-primary" @click="close">Готово</button>
                </div>
            </template>

            <template v-else-if="step === 'error'">
                <img :src="dangerIcon" alt="" class="rent-cancellation-icon">
                <h3 class="rent-cancellation-title">Произошла ошибка</h3>
                <p class="rent-cancellation-text">{{ errorText }}</p>
                <div class="rent-cancellation-actions">
                    <button type="button" class="rent-cancellation-primary" @click="close">Готово</button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import closeIcon from '../widgets/booking/assets/img/icons/booking-close.svg'
import infoIcon from '../assets/img/info.svg'
import successIcon from '../assets/img/success.svg'
import dangerIcon from '../assets/img/danger.svg'

export default {
    name: 'RentCancellationFlowModal',
    emits: ['close', 'confirm'],
    props: {
        step: { type: String, required: true },
        confirmText: { type: String, default: '' },
        loadingText: { type: String, default: 'Бронь отменяется' },
        successText: { type: String, default: '' },
        errorText: { type: String, default: 'Во время отмены брони произошла ошибка' },
    },
    data() {
        return {
            closeIcon,
            infoIcon,
            successIcon,
            dangerIcon,
        }
    },
    methods: {
        close() {
            if (this.step !== 'loading') {
                this.$emit('close')
            }
        },
    },
}
</script>

<style scoped>
.rent-cancellation-overlay {
    position: fixed;
    inset: 0;
    z-index: 1800;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: rgba(0, 0, 0, 0.5);
}

.rent-cancellation-modal {
    position: relative;
    width: 100%;
    max-width: 360px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px;
    border-radius: 30px;
    background: #fff;
}

.rent-cancellation-close {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 24px;
    height: 24px;
    padding: 5px;
    border: 0;
    border-radius: 7px;
    background: #f3f5f8;
    cursor: pointer;
}

.rent-cancellation-close img {
    width: 100%;
    height: 100%;
}

.rent-cancellation-icon {
    width: 48px;
    height: 48px;
    display: block;
    margin: 0 auto;
}

.rent-cancellation-title {
    margin: 0;
    padding: 0 24px;
    color: #333;
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    text-align: center;
}

.rent-cancellation-text {
    margin: 0;
    color: #6f7480;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
}

.rent-cancellation-actions {
    display: grid;
    gap: 8px;
    margin-top: 8px;
}

.rent-cancellation-actions--row {
    display: flex;
}

.rent-cancellation-actions--row > button {
    flex: 1;
}

.rent-cancellation-primary,
.rent-cancellation-secondary,
.rent-cancellation-danger {
    width: 100%;
    min-height: 44px;
    padding: 8px 12px;
    border: 0;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
}

.rent-cancellation-primary {
    background: var(--primary-color, #3c67d6);
    color: #fff;
}

.rent-cancellation-secondary {
    background: rgba(60, 103, 214, 0.1);
    color: var(--primary-color, #3c67d6);
}

.rent-cancellation-danger {
    background: rgba(241, 95, 148, 0.1);
    color: #ed3d3d;
}

.rent-cancellation-spinner-wrap {
    display: flex;
    justify-content: center;
    padding: 4px 0;
}

.rent-cancellation-spinner {
    width: 40px;
    height: 40px;
    display: inline-block;
    border: 4px solid #dde3f5;
    border-top-color: var(--primary-color, #3c67d6);
    border-radius: 50%;
    animation: rent-cancellation-spin 0.7s linear infinite;
}

@keyframes rent-cancellation-spin {
    to { transform: rotate(360deg); }
}
</style>
